import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import TextInput from "./formComp/TextInputOld";
import {
  DigitalModelForm,
  NightguardForm,
  OtherTreatmentsForm,
  SmileDesignForm,
  SurgicalGuideForm,
  VeneersForm,
  CompleteDentureForm,
  PartialDentureForm,
  PartialCastForm,
} from "../../types/UploadFieldsType";
import { CrownBridgeOutput, ImplantOutput } from "../../types/BlueCardTypes";


import CrownBridge from "./userCaseUpload/CrownBridgeOld";
import Implant from "./userCaseUpload/ImplantOld";
import SmileDesign from "./userCaseUpload/SmileDesignOld";
import Veneers from "./userCaseUpload/VeneersOld";
import CompleteDenture from "./userCaseUpload/CompletDentureOld";
import PartialDenture from "./userCaseUpload/PartialDentureOld";
import PartialCast from "./userCaseUpload/PartialCastOld";
import SurgicalGuide from "./userCaseUpload/SurgicalGuideOld";
import NightGuard from "./userCaseUpload/NightGuardOld";
import DigitalModel from "./userCaseUpload/DigitalModelOld";
import OtherTreatments from "./userCaseUpload/OtherTreatmentsOld";

import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { uploadCase } from "../../store/user/userSlice";
import { UploadFormData } from "../../types/UploadFormTypes";
import { useToast } from "../utilities/Toast";
import SelectInput from "./formComp/SelectInputOld";
import { useNavigate } from "react-router-dom";
import { isVelvetLabToken } from "../../utils/brandLogo";
import { isFzToken } from "../../utils/fzLab";

export const CaseDetailsForm = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.auth);
  const { employee } = useAppSelector((state) => state.allocationAuth);
  const { showToast } = useToast();
  const user_id = user?.user_id;

  const [formData, setFormData] = useState<UploadFormData>({
    case_owner: "",
    upload_token: "",
    service_type: "",
    details_json: {},
  });

  // const [splintedCrowns, setSplintedCrowns] = useState("");
  const [additionalNote, setAdditionalNote] = useState("");
  const [previewNeeded, setPreviewNeeded] = useState("");
  const [orderFormConfirmed, setOrderFormConfirmed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // NEW STATE FOR CASE PRIORITY
  const [casePriority, setCasePriority] = useState(
    "Medium priority (Regular case)"
  );

  const [crownBridgeData, setCrownBridgeData] = useState<CrownBridgeOutput>({
    occlusalContact: "",
    proximalContact: "",
    ponticDesign: "",
    instanceDetails: [],
  });

  const [implantData, setImplantData] = useState<ImplantOutput>({
    occlusalContact: "",
    proximalContact: "",
    ponticDesign: "",
    instanceDetails: [],
  });

  const [smileDesignData, setSmileDesignData] = useState<SmileDesignForm>({
    toothNumbers: [],
    photoIncluded: "",
    biteOpening: "",
    teethExtractions: [],
    waxUp: "",
    proposedTreatmentPlan: "",
    otherConsiderations: "",
  });

  const [veneersData, setVeneersData] = useState<VeneersForm>({
    toothNumbers: [],
    photoIncluded: "",
    preparation: "",
    mergedModelNeeded: "",
    placementTag: "",
    changeInVerticalDimention: "",
    otherConsiderations: "",
  });

  const [completeDentureData, setcompleteDentureData] =
    useState<CompleteDentureForm>({
      teethReplaced: [],
      occlusionType: "",
      desiredOutput: "",
      patientGender: "",
      patientAgeGroup: "",
      finishedProduct: "",
      modelNeeded: "",
      shade: "",
      additionalNotes: "",
    });
  const [partialDentureData, setpartialDentureData] =
    useState<PartialDentureForm>({
      teethReplaced: [],
      teethExtracted: [],
      desiredOutput: "",
      finishedProduct: "",
      modelNeeded: "",
      additionalNotes: "",
      shade: "",
    });
  const [partialCastData, setpartialCastData] = useState<PartialCastForm>({
    frameworkMaterial: "",
    desiredArch: "",
    majorConnectorUpperDesignType: "",
    majorConnectorUpperCreateWindow: "",
    majorConnectorLower: "",
    minorConnector: "",
    directRetainerTeeth: [],
    directRetainerClasp: "",
    indirectRetainer: "",
    rest: "",
    additionalNotes: "",
  });

  const [surgicalGuideData, setSurgicalGuideData] = useState<SurgicalGuideForm>(
    {
      dicomFile: "",
      stlFile: "",
      plannedImplantSites: [],
      plannedImplantManufacturer: "",
      teethExtractions: [],
      guideType: "",
      otherConsiderations: "",
      pilotDrillSize: "",
    }
  );

  const [nightGuardData, setNightGuardData] = useState<NightguardForm>({
    neededFor: "",
    margin: "",
    occlusalSurface: "",
    thickness: "",
  });

  const [digitalModelData, setDigitalModelData] = useState<DigitalModelForm>({
    neededFor: "",
    modelType: "",
    dieRequirement: "",
    otherPreferences: "",
    otherSpecifications: "",
  });

  const [otherTreatmentsData, setOtherTreatmentsData] =
    useState<OtherTreatmentsForm>({
      requirement: "",
    });

  const services = ["admin", "operations", "super admin"].includes(
    user?.role?.toLowerCase() || ""
  )
    ? [
      "Crown & Bridge",
      "Implant",
      "Smile Design / Mock-up",
      "No-prep Veneers",
      "LDP Complete denture",
      "LDP Partial denture",
      "RPD Framework",
      "Surgical Guide",
      "Nightguard / Bite splint",
      "Digital model",
      "Other treatments",
      "Upload filled order",
    ]
    : user?.partner === "bant"
      ? [
        "Crown & Bridge",
        "Smile Design / Mock-up",
        "Digital model",
        "LDP Complete denture",
        "LDP Partial denture",
        "RPD Framework",
        "Other treatments",
        "Upload filled order",
      ]
      : isVelvetLabToken(user?.token) || isVelvetLabToken(formData.upload_token)
        ? [
          "Crown & Bridge",
          "Implant",
          "Smile Design / Mock-up",
          "No-prep Veneers",
          "Surgical Guide",
          "Nightguard / Bite splint",
          "Digital model",
          "Other treatments",
          "Upload filled order",
        ]
        : [
          "Crown & Bridge",
          "Implant",
          "Smile Design / Mock-up",
          "Surgical Guide",
          "Nightguard / Bite splint",
          "Digital model",
          "Other treatments",
          "Upload filled order",
        ];

  const serviceMap: Record<string, string> = {
    "Crown & Bridge": "crownAndBridge",
    Implant: "Implant",
    "Smile Design / Mock-up": "smileDesign",
    "No-prep Veneers": "veneers",
    "LDP Complete denture": "complete-denture",
    "LDP Partial denture": "partial-denture",
    "RPD Framework": "partial-cast",
    "Surgical Guide": "surgicalGuide",
    "Nightguard / Bite splint": "nightguard-bite-splint",
    "Digital model": "digital-model",
    "Other treatments": "otherTreatments",
    "Upload filled order": "filledOrder",
  };

  const selectedServices = formData.service_type
    ? formData.service_type.split(",").map((s) => s.trim())
    : [];

  const handleCheckboxChange = (service: string) => {
    const key = serviceMap[service];
    if (key === "filledOrder") {
      const newState = !orderFormConfirmed;
      setOrderFormConfirmed(newState);
      setFormData((prev) => ({
        ...prev,
        service_type: newState ? "filledOrder" : "",
      }));
    } else {
      setOrderFormConfirmed(false);
      setFormData((prev) => {
        const current = prev.service_type
          ? prev.service_type
            .split(",")
            .filter((s) => s.trim() && s !== "filledOrder")
          : [];

        let updated: string[];
        if (current.includes(key)) {
          updated = current.filter((s) => s !== key);
        } else {
          updated = [...current, key];
        }

        return {
          ...prev,
          service_type: updated.join(","),
        };
      });
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name === "upload_token") {
      const sanitized = value
        .replace(/[^A-Za-z]/g, "") // remove numbers, spaces, specials
        .toUpperCase()
        .slice(0, 2); // max 2 characters

      setFormData((prev) => ({
        ...prev,
        upload_token: sanitized,
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFormKeyDown = (e: React.KeyboardEvent<HTMLFormElement>) => {
    const target = e.target as HTMLElement;
    if (e.key === "Enter" && target.tagName !== "TEXTAREA") {
      e.preventDefault();
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isFzToken(user?.token) || isFzToken(formData.upload_token)) {
      showToast(
        "FZ lab cases cannot be created from the portal. Use Local Downloader → FZ Sync.",
        "error",
      );
      return;
    }
    // Validate before submitting
    if (!validateRequiredFields()) {
      showToast("Please fill all required fields before submitting.", "error");
      return;
    }
    setIsSubmitting(true);

    const details_json: Record<string, any> = {
      patientName: formData.case_owner,
      additionalNote: additionalNote || "",
      previewNeeded: previewNeeded || "",
    };

    if (casePriority) details_json["casePriority"] = casePriority;
    if (orderFormConfirmed) details_json["UploadFilledOrder"] = true;

    // Build the services object
    const services: Record<string, any> = {};

    if (selectedServices.includes("crownAndBridge")) {
      services["crownAndBridge"] = crownBridgeData || {};
    }
    if (selectedServices.includes("Implant")) {
      services["Implant"] = implantData || {};
    }
    if (selectedServices.includes("smileDesign")) {
      services["smileDesign"] = smileDesignData || {};
    }
    if (selectedServices.includes("veneers")) {
      services["veneers"] = veneersData || {};
    }

    if (selectedServices.includes("complete-denture")) {
      services["complete-denture"] = completeDentureData || {};
    }
    if (selectedServices.includes("partial-denture")) {
      services["partial-denture"] = partialDentureData || {};
    }
    if (selectedServices.includes("partial-cast")) {
      services["partial-cast"] = partialCastData || {};
    }

    if (selectedServices.includes("surgicalGuide")) {
      services["surgicalGuide"] = surgicalGuideData || {};
    }
    if (selectedServices.includes("nightguard-bite-splint")) {
      services["nightguard-bite-splint"] = nightGuardData || {};
    }
    if (selectedServices.includes("digital-model")) {
      services["digital-model"] = digitalModelData || {};
    }
    if (selectedServices.includes("otherTreatments")) {
      services["OtherTreatments"] = otherTreatmentsData || {};
    }

    details_json["services"] = services;

    const completeFormData = {
      ...formData,
      user_id,
      details_json: JSON.stringify(details_json),
      createdBy:
        user?.role === "Super Admin"
          ? user?.user_name
          : employee
            ? employee.emp_name
            : "Client",
    };

    const result = await dispatch(uploadCase(completeFormData));
    setIsSubmitting(false);

    if (uploadCase.fulfilled.match(result)) {
      showToast("Case Details uploaded!", "success");
      navigate(`/dashboard/upload/${result.payload.case_id}`);
    } else {
      showToast("Case Details Upload failed: " + result.payload, "error");
    }
  };

  const REQUIRED_FIELDS_BY_SERVICE: Record<string, string[]> = {
    crownAndBridge: ["instanceDetails"],
    Implant: ["instanceDetails"],
    smileDesign: [
      "toothNumbers",
      "photoIncluded",
      "waxUp",
      "proposedTreatmentPlan",
    ],
    veneers: [
      "toothNumbers",
      "photoIncluded",
      "preparation",
      "mergedModelNeeded",
      "placementTag",
    ],
    "complete-denture": ["teethReplaced", "occlusionType", "desiredOutput"],
    "partial-denture": ["teethReplaced", "desiredOutput"],
    "partial-cast": ["frameworkMaterial", "desiredArch"],
    surgicalGuide: [
      "dicomFile",
      "stlFile",
      "plannedImplantSites",
      "plannedImplantManufacturer",
      "guideType",
    ],
    "nightguard-bite-splint": ["neededFor", "margin", "thickness"],
    "digital-model": ["neededFor", "modelType"],
    otherTreatments: ["requirement"],
    filledOrder: [],
  };

  // 👇 Define per-instance rules for services that have instanceDetails array
  const REQUIRED_INSTANCE_FIELDS: Record<string, string[]> = {
    crownAndBridge: [
      "toothNumbers",
      "material",
      "prosthesisType",
      "designType",
    ],
    Implant: [
      "toothNumbers",
      "material",
      "scanBodyManufacturer",
      "implantManufacturer",
      "platformDiameter",
      "restorationRequired",
      "prosthesisType",
    ],
  };

  // 👇 JU-specific required fields for Implant
  const REQUIRED_INSTANCE_FIELDS_JU_IMPLANT: string[] = [
    "toothNumbers",
    "restorationRequired",
    "prosthesisType",
    "implantSystem",
    "implantSize",
    "connectionType",
    "scanFlagType",
  ];

  const validateRequiredFields = (): boolean => {
    const { case_owner } = formData;

    // Step 1: global validation
    if (!case_owner?.trim()) {
      console.warn("Missing required field: patient name");
      return false;
    }

    if (
      (isVelvetLabToken(user?.token) || isVelvetLabToken(formData.upload_token)) &&
      !casePriority?.trim()
    ) {
      console.warn("Missing required field: Case Priority");
      return false;
    }

    if (user?.partner === "bant" && !previewNeeded?.trim()) {
      console.warn("Missing required field: Model Preview Needed");
      return false;
    }

    if (!selectedServices || selectedServices.length === 0) {
      console.warn("At least one service must be selected");
      return false;
    }

    // Step 2: service-wise validation
    for (const service of selectedServices) {
      if (service === "filledOrder") continue;

      const requiredFields = REQUIRED_FIELDS_BY_SERVICE[service] || [];
      let serviceData: Record<string, any> = {};

      switch (service) {
        case "crownAndBridge":
          serviceData = crownBridgeData || {};
          break;
        case "Implant":
          serviceData = implantData || {};
          break;
        case "smileDesign":
          serviceData = smileDesignData || {};
          break;
        case "veneers":
          serviceData = veneersData || {};
          break;
        case "complete-denture":
          serviceData = completeDentureData || {};
          break;
        case "partial-denture":
          serviceData = partialDentureData || {};
          break;
        case "partial-cast":
          serviceData = partialCastData || {};
          break;
        case "surgicalGuide":
          serviceData = surgicalGuideData || {};
          break;
        case "nightguard-bite-splint":
          serviceData = nightGuardData || {};
          break;
        case "digital-model":
          serviceData = digitalModelData || {};
          break;
        case "otherTreatments":
          serviceData = otherTreatmentsData || {};
          break;
        default:
          break;
      }

      // Step 3: top-level field validation
      for (const field of requiredFields) {
        const value = serviceData[field];
        if (
          value === undefined ||
          value === null ||
          (typeof value === "string" && !value.trim()) ||
          (Array.isArray(value) && value.length === 0)
        ) {
          console.warn(
            `Missing required field "${field}" for service "${service}"`
          );
          return false;
        }
      }

      // Step 4: special case – validate inside instanceDetails arrays
      if (["crownAndBridge", "Implant"].includes(service)) {
        const instances = serviceData.instanceDetails;
        // const instanceRequiredFields = REQUIRED_INSTANCE_FIELDS[service] || [];

        // For Implant service, check if token is JU to use different required fields
        let instanceRequiredFields: string[] = [];
        if (
          service === "Implant" &&
          (isVelvetLabToken(user?.token) || isVelvetLabToken(formData.upload_token))
        ) {
          instanceRequiredFields = REQUIRED_INSTANCE_FIELDS_JU_IMPLANT;
        } else {
          instanceRequiredFields = REQUIRED_INSTANCE_FIELDS[service] || [];
        }
        if (!Array.isArray(instances) || instances.length === 0) {
          console.warn(`No instance details found for service "${service}"`);
          return false;
        }

        for (let i = 0; i < instances.length; i++) {
          const instance = instances[i];
          for (const field of instanceRequiredFields) {
            const val = instance[field];
            if (
              val === undefined ||
              val === null ||
              (typeof val === "string" && !val.trim()) ||
              (Array.isArray(val) && val.length === 0)
            ) {
              console.warn(
                `Missing required field "${field}" in instance ${i + 1
                } of "${service}"`
              );
              return false;
            }
          }
        }
      }

      // Step 5: conditional rule for surgical guide
      if (service === "surgicalGuide") {
        const guideType = serviceData?.guideType;
        if (guideType === "Pilot-drill only") {
          const pilotDrillSize = serviceData?.pilotDrillSize;
          if (!pilotDrillSize?.trim()) {
            console.warn(
              `Missing required field "pilotDrillSize" because guideType is "Pilot-drill only"`
            );
            return false;
          }
        }
      }
    }

    return true;
  };

  return (
    <>
      <Helmet>
        <title>Upload Case</title>
      </Helmet>
      <div className="w-full bg-white rounded-2xl border-2 border-[#DDDDD8] h-full md:p-6">
        <form onSubmit={handleSubmit} onKeyDown={handleFormKeyDown}>
          <h2 className="text-xl md:text-3xl font-bold mb-4">
            Step 1/2: Enter Case Details
          </h2>
          <div className="text-sm md:text-lg">
            <div
              className={`${user?.role?.toLowerCase() === "user" ||
                user?.role?.toLowerCase() === "side admin"
                ? "hidden"
                : ""
                }
                mb-4 border-b-2 border-[#DDDDD8]
`}
            >
              <TextInput
                label="Lab Token"
                name="upload_token"
                value={formData.upload_token}
                onChange={handleInputChange}
                widthLabel="w-[36.5%] md:w-[31.5%]"
                widthInput="w-[55.5%]"
              />
            </div>

            {/*  */}
            <h2 className="tracking-tight text-[#AAAAAA] font-semibold mb-4 border-b-2 border-[#DDDDD8]">
              CASE INFORMATION
            </h2>

            <TextInput
              label="Patient Name / Job Number"
              name="case_owner"
              value={formData.case_owner}
              onChange={handleInputChange}
              widthLabel="w-[36.5%] md:w-[31.5%]"
              widthInput="w-[55.5%]"
            />

            <div className="mb-4 flex w-[90%]">
              <label className="block mb-2 w-[40%] md:w-[35%]">
                Services requested <span className="text-red-500">*</span>
              </label>
              <div className="flex flex-col gap-1 w-auto">
                {services.map((service) => {
                  const key = serviceMap[service];
                  const isFilledOrder = key === "filledOrder";
                  return (
                    <label
                      key={service}
                      className="flex items-center text-xs md:text-sm"
                    >
                      <input
                        type="checkbox"
                        className="mr-2 cursor-pointer"
                        checked={
                          isFilledOrder
                            ? orderFormConfirmed
                            : selectedServices.includes(key)
                        }
                        onChange={() => handleCheckboxChange(service)}
                        disabled={
                          (orderFormConfirmed && !isFilledOrder) ||
                          (!orderFormConfirmed &&
                            isFilledOrder &&
                            selectedServices.length > 0)
                        }
                      />
                      {service}
                    </label>
                  );
                })}
              </div>
            </div>

            {/* CASE PRIORITY FIELD */}
            {(isVelvetLabToken(user?.token) ||
              isVelvetLabToken(formData.upload_token) ||
              ["admin", "operations", "super admin"].includes(
                user?.role?.toLowerCase() || ""
              )) && (
                <SelectInput
                  label="Case Priority"
                  name="casePriority"
                  value={casePriority}
                  onChange={(e) => setCasePriority(e.target.value)}
                  options={[
                    {
                      value: "High priority(Rush case)",
                      label: "High priority(Rush case)",
                    },
                    {
                      value: "Medium priority (Regular case)",
                      label: "Medium priority (Regular case)",
                    },
                    { value: "Low priority", label: "Low priority" },
                  ]}
                  widthLabel="w-[36.5%] md:w-[31.5%]"
                  widthSelect="w-[55.5%]"
                />
              )}

            {/* is model needed - only for bant partners */}
            {(user?.partner === "bant" ||
              ["admin", "operations", "super admin"].includes(
                user?.role?.toLowerCase() || ""
              )) && (
                <SelectInput
                  label="Is model preview needed?"
                  name="previewNeeded"
                  value={previewNeeded}
                  onChange={(e) => setPreviewNeeded(e.target.value)}
                  options={[
                    { value: "Yes", label: "Yes" },
                    { value: "No", label: "No" },
                  ]}
                  widthLabel="w-[36.5%] md:w-[31.5%]"
                  widthSelect="w-[55.5%]"
                />
              )}

            <div className="border-dashed border-b-2 mb-2">
              {selectedServices.includes("crownAndBridge") && (
                <CrownBridge
                  filterToken={formData?.upload_token || user?.token || ""}
                  onChange={setCrownBridgeData}
                />
              )}
              {selectedServices.includes("Implant") && (
                <Implant
                  filterToken={formData?.upload_token || user?.token || ""}
                  onChange={setImplantData}
                />
              )}
              {selectedServices.includes("smileDesign") && (
                <SmileDesign onChange={setSmileDesignData} />
              )}
              {selectedServices.includes("veneers") && (
                <Veneers onChange={setVeneersData} />
              )}

              {selectedServices.includes("complete-denture") && (
                <CompleteDenture onChange={setcompleteDentureData} />
              )}
              {selectedServices.includes("partial-denture") && (
                <PartialDenture onChange={setpartialDentureData} />
              )}
              {selectedServices.includes("partial-cast") && (
                <PartialCast onChange={setpartialCastData} />
              )}

              {selectedServices.includes("surgicalGuide") && (
                <SurgicalGuide onChange={setSurgicalGuideData} />
              )}
              {selectedServices.includes("nightguard-bite-splint") && (
                <NightGuard onChange={setNightGuardData} />
              )}
              {selectedServices.includes("digital-model") && (
                <DigitalModel onChange={setDigitalModelData} />
              )}
              {selectedServices.includes("otherTreatments") && (
                <OtherTreatments onChange={setOtherTreatmentsData} />
              )}
            </div>

            <TextInput
              label="Additional notes"
              name="additionalNote"
              value={additionalNote}
              onChange={(e) => setAdditionalNote(e.target.value)}
              optional
              widthLabel="w-[36.5%] md:w-[31.5%]"
              widthInput="w-[55.5%]"
            />
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className={`py-1 md:py-2 px-2 md:px-4 rounded font-medium text-white ${isSubmitting || !validateRequiredFields()
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-[#2fa9bf] hover:bg-[#0b859b]"
              }`}
          >
            {isSubmitting ? "Uploading..." : "Continue to File Upload"}
          </button>
        </form>
      </div>
    </>
  );
};

export default CaseDetailsForm;
